import { Alert, Typography } from '@mui/material';

/**
 * Ostrzeżenie przy obsadzeniu autem, którego realizacja pewnie nie mieści się
 * w oknach zlecenia (22.10.2026, decyzja użytkownika pkt 3; przełącznik
 * „Wariant tylko, gdy realizacja mieści się w oknach”): furtka Team Leadera —
 * ostrzega, nie blokuje, powód nie jest wymagany. Pod zdaniem obie liczby
 * spóźnienia z opisem źródła (pkt 4) — `lateAssignmentWarningOf`.
 */
export const LateAssignmentWarning = ({
  warning,
  testId,
}: {
  warning: { text: string; lines: string[] };
  testId: string;
}) => (
  <Alert severity="warning" data-testid={testId} sx={{ py: 0 }}>
    <Typography variant="body2">{warning.text}</Typography>
    {warning.lines.map((line) => (
      <Typography key={line} variant="caption" component="div">
        {line}
      </Typography>
    ))}
  </Alert>
);
